module.exports = __webpack_public_path__ + "static/media/camionesmack.4dbb64de.jpg";